<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="酒店名字">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入酒店名字" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" @change="search" placeholder="请选择状态" clearable style="width:100%">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="reset" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <MyTable
        ref="myTableRef"
        :table-data="tableData"
        :columns="columns"
        :loading="loading"
        :total="total"
        :page-no="queryParams.pageNo"
        :page-size="queryParams.pageSize"
        @pagination-change="paginationChange"
      >
        <template #cover="{ value }">
          <el-image v-if="value" :src="fullUrl(value)" fit="cover" style="width:60px;height:60px;border-radius:4px;"
                    :preview-src-list="[fullUrl(value)]" />
          <span v-else>-</span>
        </template>
        <template #status="{ scope }">
          <el-tag :type="scope.row.status == 1 ? 'success' : 'info'" size="small">
            {{ scope.row.status == 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
        <template #operation>
          <el-table-column fixed="right" label="操作" width="140" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)">编辑</el-button>
              <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info"
                             icon-color="red" title="确定要删除吗？" @confirm="handleDel(scope.row.id)">
                <el-button slot="reference" type="text" class="PUB_BTN_RED">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </MyTable>
      <edit v-if="dialogVisible" :editID="editID" :dialogVisible="dialogVisible" @NoneDlog="NoneDlog" @AddOk="AddOk"></edit>
    </el-card>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
const api = rcApis();
export default {
  components: { Edit: () => import('./edit.vue') },
  data() {
    return {
      columns: [
        { label: 'ID', prop: 'id', width: '80' },
        { label: '酒店名字', prop: 'name' },
        { label: '封面图', prop: 'cover', slotKey: 'cover', width: '100' },
        { label: '营业时间', prop: 'business_hours', width: '140' },
        { label: '位置', prop: 'location', showOverflowTooltip: true },
        { label: '状态', prop: 'status', slotKey: 'status', width: '90' },
        { label: '排序', prop: 'listorder', width: '90' },
      ],
      queryParams: { pageNo: 1, pageSize: 10, name: "", id: '', status: '' },
      tableData: [],
      editID: "",
      total: 0,
      dialogVisible: false,
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    fullUrl(url) {
      if (!url) return '';
      if (/^https?:\/\//.test(url)) return url;
      const base = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '');
      return base + (url.startsWith('/') ? url : '/' + url);
    },
    getList(type) {
      this.loading = true;
      if (type != 'changePage') this.queryParams.pageNo = 1;
      api.HotelList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.totalCount;
        } else {
          processErrors(res);
        }
        this.loading = false;
      });
    },
    paginationChange({ pageNo, pageSize }) {
      this.queryParams.pageNo = pageNo;
      this.queryParams.pageSize = pageSize;
      this.getList('changePage');
    },
    search() { this.getList(); },
    reset() {
      this.queryParams = { pageNo: 1, pageSize: 10, name: "", id: '', status: '' };
      this.getList();
    },
    handleDel(id) {
      api.HotelDel({ id }).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功');
          this.getList('changePage');
        } else {
          processErrors(res);
        }
      });
    },
    addList() { this.editID = ""; this.dialogVisible = true; },
    NoneDlog() { this.dialogVisible = false; },
    AddOk() { this.editID = ""; this.dialogVisible = false; this.getList('changePage'); },
    handleEdit(row) { this.editID = row.id; this.dialogVisible = true; },
  },
}
</script>
<style lang='scss' scoped>
.el-card__body { padding: 0px !important; }
.btn_left { margin-left: 100px; }
.div_buttom { width: 100%; display: flex; margin-bottom: 20px; }
</style>
